import {UsersEffects} from './effects/users.effects';
import {RolesEffects} from "./effects/roles.effects";
import {DocumentsEffects} from './effects/documents.effects';
import {DashboardEffects} from './effects/dashboard.effects';
import {FiusEffects} from "./effects/fius.effects";
import {CaseEntitiesEffects} from "./effects/case-entities.effects";
import {WorkingGroupsEffects} from "./effects/working-groups.effects";
import {RelatedCasesEffects} from "./effects/related-cases.effects";
import {NotificationsEffects} from "./effects/notifications.effects";
import {CountriesEffects} from "./effects/countries.effects";

export {
  RolesEffects,
  UsersEffects,
  DocumentsEffects,
  DashboardEffects,
  FiusEffects,
  CaseEntitiesEffects,
  WorkingGroupsEffects,
  RelatedCasesEffects,
  NotificationsEffects,
  CountriesEffects
}
